import { formatPrice } from '@nespresso/catalog-sdk'
import classNames from 'classnames'
import { useEffect, useState } from 'preact/hooks'
import styles from './Price.module.scss'

type ProductPriceProps = {
    price: number
    priceDark?: boolean
    classOverride?: string
    priceBig?: boolean
    priceSmall?: boolean
    priceLight?: boolean
}

export default function Price({
    price,
    priceDark,
    priceLight,
    priceBig,
    priceSmall,
    classOverride
}: ProductPriceProps) {
    const [formattedPrice, setFormattedPrice] = useState('')

    useEffect(() => {
        const format = async () => {
            if (price) {
                try {
                    const formatted = await formatPrice(price)
                    setFormattedPrice(formatted)
                } catch (e) {
                    console.error('Could not format price')
                    console.log(e)
                }
            }
        }
        format()
    }, [price])

    if (!price || !formattedPrice) {
        return null
    }

    return (
        <span
            className={classNames(
                styles.price,
                priceDark && styles.priceDark,
                priceBig && styles.priceBig,
                priceSmall && styles.priceSmall,
                priceLight && styles.priceLight,
                classOverride
            )}>
            {formattedPrice}
        </span>
    )
}
